import { useCallback, useState } from 'react';

/**
 * Shared product-detail open state for Our Menu.
 * `openIntent` is 'cart' | 'plan' | null (null when opened from image/title).
 */
export function useOurMenuProductDetail() {
  const [selectedItem, setSelectedItem] = useState(null);
  const [openIntent, setOpenIntent] = useState(null);

  const openProduct = useCallback((item, options) => {
    setSelectedItem(item);
    setOpenIntent(options?.intent === 'plan' || options?.intent === 'cart' ? options.intent : null);
  }, []);

  const closeProduct = useCallback(() => {
    setSelectedItem(null);
    setOpenIntent(null);
  }, []);

  return { selectedItem, openIntent, openProduct, closeProduct };
}
